const notificationStatus = {
  PENDING: 'Pending',
  OK: 'OK',
}

export default notificationStatus
